import { SaoPaulo as o } from "./sao-paulo.js";
import { Shanghai as r } from "./shanghai.js";
import { Stockholm as m } from "./stockholm.js";
import { Sydney as i } from "./sydney.js";
import { SanFrancisco as t } from "./san-francisco.js";
import { NewYork as p } from "./new-york.js";
import { Madrid as f } from "./madrid.js";
import { Melbourne as a } from "./melbourne.js";
import { Milan as n } from "./milan.js";
import { Munich as e } from "./munich.js";
import { Berlin as s } from "./berlin.js";
import { Brussels as u } from "./brussels.js";
import { Paris as c } from "./paris.js";
import { Amsterdam as l } from "./amsterdam.js";
import { Boston as g } from "./boston.js";
import { Chicago as M } from "./chicago.js";
import { Dubai as h } from "./dubai.js";
import { HongKong2 as S } from "./hong-kong-2.js";
import { KualaLumpur as d } from "./kuala-lumpur.js";
import { London as B } from "./london.js";
import { MexicoCity as C } from "./mexico-city.js";
import { Tokyo as y } from "./tokyo.js";
import { SaoJoseDosCampos as b } from "./sao-jose-dos-campos.js";
import { Manchester as k } from "./manchester.js";
import { Austin as P } from "./austin.js";
import { Bengaluru as w } from "./bengaluru.js";
import { Cincinnati as x } from "./cincinnati.js";
import { Mumbai as A } from "./mumbai.js";
import { Prague as D } from "./prague.js";
import { Toronto as K } from "./toronto.js";
import { Warsaw as L } from "./warsaw.js";
import { Bangalore as T } from "./bangalore.js";
import { Remote as F } from "./remote.js";
import { Ufo as H } from "./ufo.js";
const go = {
  SaoPaulo: o,
  Shanghai: r,
  Stockholm: m,
  Sydney: i,
  SanFrancisco: t,
  NewYork: p,
  Madrid: f,
  Melbourne: a,
  Milan: n,
  Munich: e,
  Berlin: s,
  Brussels: u,
  Paris: c,
  Amsterdam: l,
  Boston: g,
  Chicago: M,
  Dubai: h,
  HongKong2: S,
  KualaLumpur: d,
  London: B,
  MexicoCity: C,
  Tokyo: y,
  SaoJoseDosCampos: b,
  Manchester: k,
  Austin: P,
  Bengaluru: w,
  Cincinnati: x,
  Mumbai: A,
  Prague: D,
  Toronto: K,
  Warsaw: L,
  Bangalore: T,
  Remote: F,
  Ufo: H
};
export {
  go as Cities
};
